import { Trans } from 'react-i18next';

import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import { SearchIcon } from '@udacity/chakra-uds-icons';

import { useI18n } from '~/hooks/use-i18n';

export function CatalogSearchNoResults({
  searchValue,
  onClearSearch,
}: {
  searchValue: string;
  onClearSearch: () => void;
}) {
  const { t } = useI18n();

  return (
    <Flex
      alignItems='center'
      bgColor='grey.50'
      borderRadius='8px'
      flexDirection='column'
      gap='16px'
      justifyContent='center'
      px={{ base: '16px', md: '80px' }}
      py='40px'
      textAlign='center'
      width='100%'
    >
      <Flex alignItems='center' flexDirection='column' gap='8px' width='100%'>
        <SearchIcon color='#7D7E87' h='32px' w='32px' />
        <Heading as='h3' color='#7D7E87' fontSize='1.25rem' fontWeight='600' letterSpacing='-0.6px' lineHeight='24px'>
          {t('catalog.noResults.searchHeading')}
        </Heading>
        <Text color='#7D7E87' fontSize='0.875rem' lineHeight='22px'>
          <Trans
            i18nKey='catalog.noResults.searchBody'
            values={{ query: searchValue }}
            components={{
              br: <br />,
              strong: <Text as='strong' fontWeight='600' />,
            }}
          />
        </Text>
      </Flex>
      <Button
        _hover={{ bgColor: 'blue.700' }}
        bgColor='blue.500'
        color='white'
        fontFamily='body'
        fontSize='0.75rem'
        fontWeight='400'
        h='auto'
        lineHeight='1.4'
        px='14px'
        py='10px'
        type='button'
        onClick={onClearSearch}
      >
        {t('catalog.noResults.clearSearch')}
      </Button>
    </Flex>
  );
}
